// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__NYS71","large":"styles_large__1hm7U"};